import { getPendingChangeOutlinedHighlightStyles } from '@sharedCR/common/form/shared/styles';

import { getConditionalObject } from 'utils/data';

export const ORDER_CONTACTS_GRID_TEMPLATE_COLUMNS =
  '64px 120px minmax(300px, 2fr) minmax(160px, 1.2fr) 128px 48px';

// The highlight outline is an :after overlay spanning the whole card; unlike the read-only
// surcharges card, this one is interactive, so the overlay must let clicks through.
export const getCardStyles = ({ isFieldChanged }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  padding: '16px',
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  borderRadius: '4px',

  ...getConditionalObject(isFieldChanged, () =>
    getPendingChangeOutlinedHighlightStyles(1, { pointerEvents: 'none' }),
  ),
});

export const headerSpacerStyles = {
  flex: 1,
};

export const tableWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  borderRadius: '4px',
};

export const headerRowStyles = {
  display: 'grid',
  gridTemplateColumns: ORDER_CONTACTS_GRID_TEMPLATE_COLUMNS,
  gap: '16px',
  alignItems: 'center',
  padding: '10px 16px',
  backgroundColor: ({ palette }) => palette.background.default,
  borderBottom: ({ palette }) => `1px solid ${palette.border.default}`,
  borderRadius: '4px 4px 0 0',
};

export const centeredCellStyles = {
  display: 'flex',
  justifyContent: 'center',
};

export const getHeaderCellStyles = ({ isCentered }) =>
  getConditionalObject(isCentered, centeredCellStyles);

export const addContactWrapperStyles = {
  display: 'flex',
};
